import React, { useState } from "react";
import { Select, SelectProps } from "antd";

interface FloatSelectProps extends SelectProps {
    label: string,
    isPassword?: boolean,
    required?: boolean,
    children?: React.ReactNode,
}

const FloatSelect = (props: FloatSelectProps) => {
    const [focus, setFocus] = useState(false);
    let { label, placeholder, required, isPassword, children, ...rest } = props;

    if (!placeholder) placeholder = label;

    //   const isOccupied = focus || (value && value.length !== 0);
    const isOccupied = focus || (rest.value || rest.value === 0);

    const labelClass = isOccupied && label ? "label as-label" : "label as-placeholder";

    const requiredMark = required ? <span className="text-danger">*</span> : null;

    return (
        <div
            className="custom-select"
            onBlur={() => setFocus(false)}
            onFocus={() => setFocus(true)}
        >
            <Select {...rest}>{children}</Select>
            <label className={labelClass}>
                {isOccupied ? label : placeholder} {requiredMark}
            </label>
        </div>
    );
};

export default FloatSelect;
